export var useUserPartyId = function () { return localStorage.getItem('userPartyId'); };
